import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

@Injectable()
export class TerminalDiscoveryHeaderService {
  constructor (private http: Http) {}

  @InvokeThrottle()
  @ParamsClean()
  getDiscoveryStats () {
    return this.http.post('/client_find/discovered_list', { limit: 1, page: 1 }).then(response => ({
      un_join_count: response.un_join_count || 0
    }))
  }
}

